import { EFFECTIVE, LEGAL_EMAIL } from './legal';

/** Renders a legal document from ./legal.js */
export default function LegalPage({ doc }) {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="border-b border-gray-200 bg-white py-12">
        <div className="mx-auto max-w-4xl px-4 text-center">
          <img src="/logos/discx/discx-icon-3D.png" alt="DiSCX-US" className="mx-auto mb-4 h-20 w-20 drop-shadow-lg" />
          <h1 className="text-3xl font-bold text-[#1a365d]">{doc.title}</h1>
          <p className="mt-2 text-[#718096]">Last updated: {EFFECTIVE}</p>
          <p className="mx-auto mt-4 max-w-2xl text-[#4a5568]">{doc.intro}</p>
        </div>
      </div>

      <div className="mx-auto max-w-4xl px-4 py-12">
        <article className="rounded-xl bg-white p-6 shadow-sm md:p-10">
          {doc.summary && (
            <div className="mb-10 rounded-xl border border-blue-100 bg-blue-50 p-6">
              <h2 className="mb-3 text-xl font-bold text-[#1a365d]">The short version</h2>
              <ul className="list-disc space-y-1.5 pl-5 text-[#4a5568]">
                {doc.summary.map((x) => <li key={x}>{x}</li>)}
              </ul>
            </div>
          )}
          {doc.sections.map((s, i) => (
            <section key={s.h} className="mb-10 last:mb-0">
              <h2 className="mb-4 text-xl font-bold text-[#1a365d]">{i + 1}. {s.h}</h2>
              {s.p?.map((x) => <p key={x} className="mb-4 leading-relaxed text-[#4a5568]">{x}</p>)}
              {s.sub?.map((sub) => (
                <div key={sub.h} className="mb-4">
                  <h3 className="mb-2 text-lg font-semibold text-[#1a365d]">{sub.h}</h3>
                  {sub.p.map((x) => <p key={x} className="mb-3 leading-relaxed text-[#4a5568]">{x}</p>)}
                </div>
              ))}
              {s.list && (
                <ul className="mb-4 list-disc space-y-2 pl-6 leading-relaxed text-[#4a5568]">
                  {s.list.map((x) => <li key={x}>{x}</li>)}
                </ul>
              )}
              {s.after?.map((x) => <p key={x} className="mb-4 leading-relaxed text-[#4a5568]">{x}</p>)}
              {s.contact && (
                <p className="rounded-lg bg-gray-50 p-4 text-[#4a5568]">
                  <strong className="text-[#1a365d]">DiSCX-US LLC</strong>
                  <br />
                  Email: <a href={`mailto:${LEGAL_EMAIL}`} className="font-semibold text-[#2563eb] hover:underline">{LEGAL_EMAIL}</a>
                </p>
              )}
            </section>
          ))}
        </article>
      </div>
    </div>
  );
}
